<div class="list-auction-fees-card">
  <form name="listAuctionFeesForm" 
    [formGroup]="listAuctionFeesForm" 
    (ngSubmit) = "onSubmitListAuctionFeesForm()" style="margin-bottom: 35px;">
    <div style="display:flex">
      <div class="form-group" style="margin-right: 25px;">
        <div class="label">Unique Client ID:</div>
        <p-multiSelect #multiSelectState [options]="clientId"
            [(ngModel)]="selectedClientId" 
            formControlName="ClientId"
            [defaultLabel]="'Select One'"
            filterBy="value,label">
        </p-multiSelect>
        <i>
            <span 
                [ngClass]="(selectedClientId && selectedClientId.length> 0) ? 'check-circle-green':'check-circle-gray'">
                <i class="pi pi-check-circle"></i>
            </span>
        </i>
      </div>
      <div class="form-group" style="margin-right: 25px;">
        <div class="label">Loan Type:</div>
        <p-multiSelect #multiSelectState [options]="loanType"
            [(ngModel)]="selectedLoanType" 
            formControlName="LoanType"
            [defaultLabel]="'Select One'"
            filterBy="value,label">
        </p-multiSelect>
        <i>
            <span 
                [ngClass]="(selectedLoanType && selectedLoanType.length> 0) ? 'check-circle-green':'check-circle-gray'">
                <i class="pi pi-check-circle"></i>
            </span>
        </i>
      </div>
      <div class="form-group" style="margin-right: 25px;">
        <div class="label">Type of Sale:</div>
        <p-multiSelect #multiSelectState [options]="typeOfSale"
            [(ngModel)]="selectedTypeOfSale" 
            formControlName="TypeOfSale"
            [defaultLabel]="'Select One'"
            filterBy="value,label">
        </p-multiSelect>
        <i>
            <span 
                [ngClass]="(selectedTypeOfSale && selectedTypeOfSale.length> 0) ? 'check-circle-green':'check-circle-gray'">
                <i class="pi pi-check-circle"></i>
            </span>
        </i>
      </div>
      <div class="form-group" style="margin-right: 25px;">
        <div class="label">Fee Type:</div>
        <p-multiSelect #multiSelectState [options]="feeType"
            [(ngModel)]="selectedFeeType" 
            formControlName="FeeType"
            [defaultLabel]="'Select One'"
            filterBy="value,label">
        </p-multiSelect>
        <i>
            <span 
                [ngClass]="(selectedFeeType && selectedFeeType.length> 0) ? 'check-circle-green':'check-circle-gray'">
                <i class="pi pi-check-circle"></i>
            </span>
        </i>
      </div>
      <div class="form-group" style="margin-right: 25px" >
        <div class="label">Fee Amount :</div>
        <input pInputText type="text" [(ngModel)]="feeAmount" placeholder="Fee Amount" size="25" formControlName="FeeAmount">
      </div>
      <div class="form-group buttonSection">
        <button pButton  type="submit" label="View" [disabled]="!listAuctionFeesForm.valid" class="margin-left-view-button"></button>&nbsp;
        <button pButton  type="button" label="Reset" (click)="resetForm()" class="ui-button-secondary margin-left"></button>
      </div>
    
    </div>
  </form>

  <p-table #dt [value]="data"
    [columns]="cols"
    [rows]="10"
    [paginator]="isPaginatorVisible()"
    [totalRecords]="records" 
    selectionMode="multiple" 
    [(selection)]="selectedItems"
    [rowsPerPageOptions]="[10,25,50]"
    [globalFilterFields]="['UniqueClientID', 'LoanType', 'TypeOfSale','FeeType','FeeAmount']" 
    [loading]="loadingSearchResult"
    (onHeaderCheckboxToggle)="onTableHeaderCheckboxToggle($event)"
    (onPage)="resetSelections($event)" >

    <ng-template pTemplate="caption">
      <div style="float: right;display: flex;margin-top: -30px;" *ngIf="data && data.length >0">
          <i class="pi pi-search" style="margin:4px 4px 0 0"></i>
          <input type="text" pInputText size="35" placeholder="Filter by:ClientId,Loan Type,Fee Type,Fee Amount " (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">&nbsp;&nbsp;
          <div style="margin-top: 1.5%;font-size: 0.9em;">
              {{records}} Records Found
          </div>&nbsp;&nbsp;
      </div>
    </ng-template>

    <ng-template  pTemplate="header">
      <tr #header *ngIf="formSubmitted">
          <th style="width: 3em">
            <p-tableHeaderCheckbox  ></p-tableHeaderCheckbox>
          </th>
          <ng-container *ngFor="let col of cols">
              <th *ngIf="col.showInHeader">
                  {{col.header}}
              </th>
          </ng-container>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr *ngIf="!loadingSearchResult && data && formSubmitted  && data.length === 0">
          <td [attr.colspan]="5" class="center-align">No records found</td> 
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns" let-expanded="expanded">
      <tr>
          <td>
              <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
          </td>
          <ng-container *ngFor="let col of columns">
            <!-- <tr > -->
              <td *ngIf="col.showInHeader && col.field != 'action'">
                  {{rowData[col.field]}}
              </td>
             
              <td *ngIf="col.showInHeader && col.field == 'action'">
                <a (click)="showEditAuctionFees(rowData)" class="anchorClass">
                  <i class="pi  pi-pencil" style="font-size: 1.3em" ></i>
                </a>&nbsp;
              </td>
            <!-- </tr> -->
          </ng-container>
      </tr>
    </ng-template>
    <ng-template pTemplate="paginatorleft" let-state>
      <button pButton type="button" label="Delete" (click)="deleteSelected()" 
          [disabled]="!(selectedItems && selectedItems.length>0)">
      </button>    
    </ng-template>
  </p-table>  

  
</div>
